import React from "react";
import Toaster from "../Shared/Toaster";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { PUBLIC_INITIAL_ROUTE } from "../utils/constants";
import { homePathPreservingReturn } from "../utils/postLoginRedirect";

export function PrivateRoute({ Component, props }) {
  const location = useLocation();
  const { user } = useSelector((state) => state.user);

  if (user === null) {
    const returnTo = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={homePathPreservingReturn(PUBLIC_INITIAL_ROUTE, returnTo)}
        replace
      />
    );
  } else {
    if (props?.role?.includes(user?.role)) {
      return <Component {...props} />;
    } else {
      Toaster.error("You are not authorized for this route.")
      return <Navigate to={location.state?.from || "/"} />;
    }
  }
}